import { SessionTranslation } from 'api/admin/models';
import { actionsFactories } from 'store/entities/utils';
import { EntityType } from 'store/entities/types';
import * as keyWindowNames from './keyWindowNames';
import { GetAdminEventSessionTranslationsType } from './types';

export const getAdminSessionsTranslations = actionsFactories.createGetManyActionsFactory<
  EntityType<SessionTranslation>,
  GetAdminEventSessionTranslationsType
>()(
  'GET_ADMIN_SESSIONS_TRANSLATION_REQUEST',
  'GET_ADMIN_SESSIONS_TRANSLATION_SUCCESS',
  'GET_ADMIN_SESSIONS_TRANSLATION_FAILURE',
  'GET_ADMIN_SESSIONS_TRANSLATION_RESET',
  keyWindowNames.adminEventSessionsTranslations,
);

export const updateAdminSessionTranslation = actionsFactories.createUpdateOneActionsFactory<
  EntityType<SessionTranslation>,
  GetAdminEventSessionTranslationsType
>()(
  'UPDATE_ADMIN_SESSIONS_TRANSLATION_REQUEST',
  'UPDATE_ADMIN_SESSIONS_TRANSLATION_SUCCESS',
  'UPDATE_ADMIN_SESSIONS_TRANSLATION_FAILURE',
  'UPDATE_ADMIN_SESSIONS_TRANSLATION_RESET',
);
